import { AlertDialog, Button, Flex } from '@radix-ui/themes'
import { Link2Icon, TrashIcon } from '@radix-ui/react-icons'
import { ShareImageLinkDialog } from './ShareImageLinkDialog'

interface PhotoLightboxFooterProps {
  /** Ops storage key; null for an image hosted elsewhere, which has no link to mint. */
  sharePath: string | null
  /** Omitted when the viewer may not delete, or when the resource is not deletable here. */
  onDelete?: {
    run: () => void
    confirmTitle: string
    confirmDescription: string
  }
}

export const PhotoLightboxFooter = ({ sharePath, onDelete }: PhotoLightboxFooterProps) => (
  <Flex gap="2" justify="end" className="w-full">
    {sharePath ? (
      <ShareImageLinkDialog
        path={sharePath}
        trigger={
          <Button variant="soft" color="gray">
            <Link2Icon />
            Share link
          </Button>
        }
      />
    ) : null}
    {onDelete ? (
      <AlertDialog.Root>
        <AlertDialog.Trigger>
          <Button variant="soft" color="red">
            <TrashIcon />
            Delete
          </Button>
        </AlertDialog.Trigger>
        <AlertDialog.Content maxWidth="440px">
          <AlertDialog.Title>{onDelete.confirmTitle}</AlertDialog.Title>
          <AlertDialog.Description size="2">{onDelete.confirmDescription}</AlertDialog.Description>
          <Flex gap="3" mt="4" justify="end">
            <AlertDialog.Cancel>
              <Button variant="soft" color="gray">
                Cancel
              </Button>
            </AlertDialog.Cancel>
            <AlertDialog.Action>
              <Button variant="solid" color="red" onClick={onDelete.run}>
                Delete
              </Button>
            </AlertDialog.Action>
          </Flex>
        </AlertDialog.Content>
      </AlertDialog.Root>
    ) : null}
  </Flex>
)
